<div class="blog-page">

  <div class="blog-header">
    <h1 class="blog-title">Conteúdos</h1>
    <p class="blog-subtitle">Aqui sua Jornada Contábil fica mais fácil</p>
  </div>

  <div class="blog-content">

    <a routerLink="/conteudos/extermine-a-perda-de-documentos" class="blog-destaque">
      <div class="destaque-img-wrap">
        <img src="assets/img/perda.jpg" alt="Extermine a perda de documentos" class="destaque-img" loading="lazy" />
      </div>
      <div class="destaque-info">
        <span class="destaque-categoria">Sobre o Mister</span>
        <h2 class="destaque-titulo">Extermine a perda de documentos</h2>
        <p class="destaque-desc">Extermine a perda de documentos no seu escritório contábil de maneira simples.</p>
      </div>
    </a>

    <a routerLink="/conteudos/experiencia-do-cliente-em-escritorios-contabeis" class="blog-destaque">
      <div class="destaque-img-wrap">
        <img src="assets/img/cliente.jpg" alt="Experiência do cliente em escritórios contábeis" class="destaque-img" loading="lazy" />
      </div>
      <div class="destaque-info">
        <span class="destaque-categoria">Contabilidade</span>
        <h2 class="destaque-titulo">Experiência do cliente em escritórios contábeis!</h2>
        <p class="destaque-desc">Como melhorar a experiência do cliente em escritórios contábeis.</p>
      </div>
    </a>

  </div>

</div>
